import { useQuery } from '@tanstack/react-query';

import { LocaleCode } from '@locale/locale-store';
import { setLocale } from '@locale/translate';

import { themeToCSSVariables } from 'utils/theme-to-css-variables';

import { request } from './request';

export type Company = {
  url: string;
  banner: string | null;
  logo: string | null;
  logoHeight: number;
  theme: Record<string, string>;
  defaultLanguage?: LocaleCode | null;
};

export const useCompany = (name: string) => {
  return useQuery({
    queryKey: ['company', name],
    queryFn: async () => {
      const response = await request.get<Company>(`company/${name}/`);
      return response.data;
    },
    onSuccess: (data) => {
      themeToCSSVariables(data.theme);

      if (data.defaultLanguage) {
        setLocale(data.defaultLanguage);
      }
    },
  });
};
